export default {
  props: {
    info: {
      type: Object,

      default() {
        return {
          course_name: '',
          course_url: '',
          credit: 0,
          course_cover_url: null,
          hours: '',
          id: '',
          lecturer: '',
          organ_name: '',
          students_num: 0
        };
      }

    },
    userInfo: {
      type: Object,
      default: null
    },
    authType: Number
  },
  computed: {
    coverIndex() {
      let id = String(this.info.id);
      let length = id.length;
      let lastId = id.charAt(length - 1);
      return lastId % 4;
    }

  },

  data() {
    return {
      defaultCover: [require('@/assets/images/course_bg1.png'), require('@/assets/images/course_bg2.png'), require('@/assets/images/course_bg3.png'), require('@/assets/images/course_bg4.png')]
    };
  }

};